import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ShoppingCart, User } from 'lucide-react';
import { useMobileOptimizations } from '../hooks/useMobileOptimizations';

const GarcomBottomNav: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isMobile } = useMobileOptimizations();

    if (!isMobile) return null;
    if (location.pathname.includes('/garcom/comanda/')) return null;
    if (location.pathname.includes('/garcom/mesa/')) return null;

    const getActiveClass = (path: string) =>
        location.pathname === path ? 'text-orange-500 scale-110' : 'text-gray-400 hover:text-white';

    const getActiveIndicator = (path: string) =>
        location.pathname === path ? 'opacity-100 scale-100' : 'opacity-0 scale-50';

    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-40 bg-gray-900 border-t border-gray-800 shadow-[0_-10px_20px_rgba(0,0,0,0.5)] backdrop-blur-md pb-safe"
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
            <div className="flex items-center justify-around h-16 px-2">
                {/* Mesas */}
                <button
                    onClick={() => navigate('/garcom/home')}
                    className="relative flex flex-col items-center justify-center w-full h-full space-y-1 active:scale-95 transition-transform touch-manipulation pb-1"
                >
                    <div className={`transition-all duration-300 ${getActiveClass('/garcom/home')}`}>
                        <Home className="h-6 w-6" />
                    </div>
                    <span className={`text-[10px] sm:text-xs font-medium transition-colors ${location.pathname === '/garcom/home' ? 'text-orange-500' : 'text-gray-500'}`}>
                        Mesas
                    </span>
                    <div className={`absolute -top-3 w-1.5 h-1.5 rounded-full bg-orange-500 transition-all duration-300 ${getActiveIndicator('/garcom/home')}`} />
                </button>

                {/* Avulsas */}
                <button
                    onClick={() => navigate('/garcom/home#avulsas')}
                    className="relative flex flex-col items-center justify-center w-full h-full space-y-1 active:scale-95 transition-transform touch-manipulation pb-1"
                >
                    <div className={`transition-all duration-300 text-gray-400 hover:text-white`}>
                        <ShoppingCart className="h-6 w-6" />
                    </div>
                    <span className="text-[10px] sm:text-xs font-medium text-gray-500">Avulsas</span>
                </button>

                {/* Perfil / Sair */}
                <button
                    onClick={() => navigate('/garcom/login')}
                    className="relative flex flex-col items-center justify-center w-full h-full space-y-1 active:scale-95 transition-transform touch-manipulation pb-1"
                >
                    <div className={`transition-all duration-300 ${getActiveClass('/garcom/login')}`}>
                        <User className="h-6 w-6" />
                    </div>
                    <span className={`text-[10px] sm:text-xs font-medium transition-colors ${location.pathname === '/garcom/login' ? 'text-orange-500' : 'text-gray-500'}`}>
                        Perfil
                    </span>
                    <div className={`absolute -top-3 w-1.5 h-1.5 rounded-full bg-orange-500 transition-all duration-300 ${getActiveIndicator('/garcom/login')}`} />
                </button>
            </div>
        </div>
    );
};

export default GarcomBottomNav;
